export default __webpack_public_path__ + "static/media/icon-with-padding.df8827bd.png";